/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import * as _ from 'lodash'
import { HttpClient } from '@angular/common/http'
import { ClikProjectInfo } from '../../types/clik/ClikProjectInfo'

@Component({
    selector: 'app-datamanager',
    templateUrl: './datamanager.component.html',
    styleUrls: ['./datamanager.component.less'],
})
export class DatamanagerComponent implements OnInit {
    @Output() changeEvent = new EventEmitter<ClikProjectInfo>()

    constructor(private $http: HttpClient) {}

    public clikConfigurationNames = []

    ngOnInit(): void {
        let vm = this
        vm.configurations().then(function (result: any) {
            vm.clikConfigurationNames = result
        })
    }

    configurations() {
        let vm = this
        let promise = vm.$http
            .get('/api/clik/configurations')
            .toPromise()
            .then(
                function (result: any) {
                    console.log('Got Good response for configurations' + result)
                    return _.filter(result.records, function (rec) {
                        // Filter out the cliksales entry, it's only there because some underlying backend code requires it.
                        // Also filter out the CRM entry since that shouldn't be changed.
                        // TODO: Control this with permisisons
                        return !['cliksales', 'clikcrm'].includes(rec)
                    })
                },
                function (result) {
                    console.log('Got Bad Result for configurations')
                    return []
                }
            )
            .then(function (value) {
                return value
            })
        return promise
    }

    emitChange(info: any) {
        let vm = this
        vm.changeEvent.emit(info)

        console.log('[Data Manager] Updating Project: ', info)
    }
}
